// extracted by mini-css-extract-plugin
module.exports = {"HtmlContent":"AccordionHtml_HtmlContent___lPZl"};